<template lang="pug">
DropdownMenuRoot(v-model:open="toggleState" :modal="false")
	DropdownMenuTrigger.menu-trigger(aria-label="Customise options" :as-child="true")
		slot(name="trigger")
	DropdownMenuPortal(:defer="true")
		DropdownMenuContent.menu-content(:class="props.type" :side-offset="8" :hide-when-detached="true" :align="type === 'venue' ? 'start' : 'end'")
			slot(name="content")
</template>

<script lang="ts" setup>
import {
	DropdownMenuContent,
	DropdownMenuPortal,
	DropdownMenuRoot,
	DropdownMenuTrigger
} from 'reka-ui'

const props = defineProps({
	type: {
		type: String as PropType<'common' | 'language' | 'nav' | 'venue'>,
		default: 'common'
	}
})

const toggleState = ref(false)
const emit = defineEmits(['toggle'])

watch(toggleState, () => {
	emit('toggle', toggleState.value)
})
</script>

<style lang="sass" scoped>
:deep(.dropdown-item)
	padding: $spacing-8 $spacing-24
	@include fontSize(s)
	letter-spacing: 0.1px
:deep(.menu-content)
	text-align: left
	border-radius: $radius-default
	background-color: $color-grey-80
	box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.35)
	padding: $spacing-8 0
	width: 216px
	&.language
		width: inherit
	&.nav
		width: 280px
		z-index: 100 !important
:deep(.dropdown-arrow)
	fill: $color-grey-80

.mobile-nav-menu
	.dropdown-menu
		min-width: 271px
		margin-top: $spacing-8
		@media (min-width: 350px)
			min-width: 300px
.dropdown-menu
	margin-top: $spacing-8
	overflow: hidden
.nav-user-dropdown
	.dropdown-menu
		width: 280px
// div[data-reka-popper-content-wrapper]
// 	z-index: 100
</style>
